import { render, staticRenderFns } from "./Creative.vue?vue&type=template&id=0865d71c"
import script from "./Creative.vue?vue&type=script&lang=js"
export * from "./Creative.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports